export default {
      id: "bulle_agenda-usage",
      viewBox: "0 0 300 286",
      url: "../dist/images/" + "sprite.svg#bulle_agenda-usage",
      toString: function () {
        return this.url;
      }
    }